export const fetchWrapper = {
    get: (url) => fetchData(null, null, url, handleResponse),
    getWithToken: (token, url) => fetchData(token, null, url, handleResponse),
    getWithApiKey: (apiKey, url) => fetchData(null, apiKey, url, handleResponse),
    post: (url, body, isJSON = true) => postData(null, null, url, body, isJSON),
    postWithToken: (token, url, body, isJSON = true) => postData(token, null, url, body, isJSON),
    postWithApiKey: (apiKey, url, body, isJSON = true) => postData(null, apiKey, url, body, isJSON),
    put: (url, body, isJSON = true) => putData(null, null, url, body, isJSON),
    putWithToken: (token, url, body, isJSON = true) => putData(token, null, url, body, isJSON),
    putWithApiKey: (apiKey, url, body, isJSON = true) => putData(null, apiKey, url, body, isJSON),
    delete: (url, isJSON = true) => deleteData(null, null, url, isJSON),
    deleteWithToken: (token, url, isJSON = true) => deleteData(token, null, url, isJSON),
    deleteWithApiKey: (apiKey, url, isJSON = true) => deleteData(null, apiKey, url, isJSON),
};

function createHeaders(token, apiKey, isJSON = true) {
    const headers = {
        'Accept': '*/*',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
        'Access-Control-Allow-Headers': 'Origin, Content-Type, Accept',
    };

    if (apiKey) {
        headers['ApiKey'] = `${apiKey}`;
    }

    if (token) {
        headers['Authorization'] = `Bearer ${token}`;
    }

    if (isJSON) {
        headers['Content-Type'] = 'application/json';
    }

    return headers;
}

function fetchData(token, apiKey, url, responseHandler) {
    const requestOptions = {
        method: 'GET',
        headers: createHeaders(token, apiKey),
    };

    return fetch(url, requestOptions).then(responseHandler);
}

function postData(token, apiKey, url, body, isJSON = true) {
    return sendData('POST', token, apiKey, url, body, isJSON);
}

function putData(token, apiKey, url, body, isJSON = true) {
    return sendData('PUT', token, apiKey, url, body, isJSON);
}

function deleteData(token, apiKey, url, isJSON = true) {
    return sendData('DELETE', token, apiKey, url, isJSON);
}

function sendData(method, token, apiKey, url, body, isJSON = true) {
    const requestOptions = {
        method: method,
        headers: createHeaders(token, apiKey, isJSON),
        body: isJSON ? JSON.stringify(body) : body,
    };

    return fetch(url, requestOptions).then(handleResponse);
}

function tryParseJSON(inputString) {
    try {
        return JSON.parse(inputString);
    } catch (error) {
        return JSON.parse(JSON.stringify({ error: error.message, message: inputString }));
    }
}

function handleResponse(response) {
    return response.text().then(text => {
        const data = text && tryParseJSON(text);
        return response.ok ? data : Promise.reject((data && data.message) || response.statusText);
    });
}